import { takeLatest, put, call, select } from 'redux-saga/effects';
import { restaurarTransaction } from '../service';
import {
  RESTAURAR_TRANSACTION_CONCILIACAO,
  RESTAURAR_TRANSACTION_CONCILIACAO_PENDING,
  RESTAURAR_TRANSACTION_CONCILIACAO_SUCCESS,
  RESTAURAR_TRANSACTION_CONCILIACAO_FAILURE,
  NEW_FILTER_CONCILIACAO_BANCARIA,
  BUSCAR_RESUMO_CONCILIACAO,
} from '@handler';
import { AlertSuccess, AlertError } from '@components/common/AlertToast';
// import { trackingEventCX, MODULE_ACTIONS_ENUM } from '@handler/tracking/customerX';

function* sagaConciliacaoRestaurar(action) {
  yield put({ type: RESTAURAR_TRANSACTION_CONCILIACAO_PENDING });

  try {
    yield call(restaurarTransaction, action.id);
    // trackingEventCX('action', MODULE_ACTIONS_ENUM.RESTAURAR_TRANSACTION_CONCILIACAO);

    yield put({ type: RESTAURAR_TRANSACTION_CONCILIACAO_SUCCESS });

    // Recarregar dados da listagem após sucesso, preservando o filtro de tipo (entradas/saídas)
    const currentFilter = yield select(state => state.entities.conciliacaoBancariaReducer.filter);
    yield put({
      type: NEW_FILTER_CONCILIACAO_BANCARIA,
      newFilter: true, // Usar true para preservar tipoTransacao
      args: {
        ...currentFilter,
        page: currentFilter.page || 0 // Manter na mesma página se possível
      }
    });

    // Atualizar resumo da conciliação
    const contaBancoId = currentFilter.contaBanco?.id;
    if (contaBancoId) {
      yield put({
        type: BUSCAR_RESUMO_CONCILIACAO,
        contaBancoId
      });
    }

    AlertSuccess('Registro restaurado com sucesso!');
  } catch (error) {
    yield put({ type: RESTAURAR_TRANSACTION_CONCILIACAO_FAILURE });
    AlertError('Falha ao restaurar o registro! Tente novamente...');
  }
}

export default function* watchConciliacaoRestaurarTransaction() {
  yield takeLatest(RESTAURAR_TRANSACTION_CONCILIACAO, sagaConciliacaoRestaurar);
}
